// see https://www.youtube.com/watch?v=re2JFITR7TI

import { clsx, ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function hexToRGB(hex: string): string {
    // remove leading '#' if present
    hex = hex.replace(/^#/, '')

    // handle short form (#FFF)
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((c) => c + c)
            .join('')
    }

    if (hex.length !== 6) {
        throw new Error('Invalid hex color')
    }

    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    return `(${r}, ${g}, ${b})`
}
